import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from 'containers/App';
import AssignmentsPage from 'containers/AssignmentsPage';
import ContentPage from 'containers/ContentPage';
import DownloadPage from 'containers/DownloadPage';
import ExpiredPage from 'containers/AuthPages/ExpiredPage';
import HomePage from 'containers/HomePage';
import LoginPage from 'containers/AuthPages/LoginPage';
import LogoutPage from 'containers/AuthPages/LogoutPage';
import ForgotPasswordPage from 'containers/AuthPages/ForgotPasswordPage';
import NotFoundPage from 'containers/NotFoundPage';
import PinpointsPage from 'containers/PinpointsPage';
import ReportsPage from 'containers/ReportsPage';
import ResetPasswordPage from 'containers/AuthPages/ResetPasswordPage';
import SignupPage from 'containers/AuthPages/SignupPage';
import UsersPage from 'containers/UsersPage';
import UsersGroupsPage from 'containers/UsersPage/UsersGroupsPage';
import UsersIndividualsPage from 'containers/UsersPage/UsersIndividualsPage';


const requireAuth = (nextState, replace) => {
    //TODO: Make this actually work
    if (false) {
        replace({ pathname: '/' })
    }
};

const Routes = (
    <Route path="/"                     component={App}>
        <IndexRoute                     component={HomePage} />
        <Route path="assignments(/new)" component={AssignmentsPage}         onEnter={requireAuth} />
        <Route path="content"           component={ContentPage}             onEnter={requireAuth} />
        <Route path="download"          component={DownloadPage} />
        <Route path="expired"           component={ExpiredPage} />
        <Route path="forgot-password"   component={ForgotPasswordPage} />
        <Route path="login"             component={LoginPage} />
        <Route path="logout"            component={LogoutPage} />
        <Route path="pinpoints"         component={PinpointsPage}           onEnter={requireAuth} />
        <Route path="reports"           component={ReportsPage}             onEnter={requireAuth} />
        <Route path="reset-password"    component={ResetPasswordPage} />
        <Route path="signup"            component={SignupPage} />
        <Route path="users/"            component={UsersPage}>
            <Route path="individuals"   component={UsersIndividualsPage}    onEnter={requireAuth} />
            <Route path="groups"        component={UsersGroupsPage}         onEnter={requireAuth} />
        </Route>
        <Route path='*'                 component={NotFoundPage} />
    </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/containers/Root/Routes.js